import Logic from './logic';
import dsl from './dsl.json';


const logic = new Logic({ dsl });



export default logic;
